import { Button } from "@material-ui/core";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Contact.css";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';

const Contact = ({lng}) => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
 
  // Definisanje locale objekta za Open Graph meta tagove
  const ogLocales = {
    en: 'en_US',
    es: 'es_ES',
    de: 'de_DE',
    fr: 'fr_FR',
    pt: 'pt_BR',
    sr: 'sr_RS'
  };

  return (
     <div className="contact">
        <Helmet>
          {/* --- TITLE & CANONICAL --- */}
          <title>{t("Contact us")}</title>
          
          <link rel="canonical" href={lng !== "en" ? `https://iscodingforyou.com/${lng}/contact/` : `https://iscodingforyou.com/contact/`} />
          
          {/* --- DESCRIPTION --- */}
          {/* Prebačen Description u t() funkciju da bi i to bilo prevedeno */}
          <meta name="description" content={t("Have questions about our coding potential test? Contact our 24/7 customer support team at support@iscodingforyou.com.")}/>
          <meta charSet="utf-8" />

          {/* --- HREFLANG TAGOVI --- */}
          <link rel="alternate" hreflang="en" href="https://iscodingforyou.com/contact/" />
          <link rel="alternate" hreflang="es" href="https://iscodingforyou.com/es/contact/" />
          <link rel="alternate" hreflang="de" href="https://iscodingforyou.com/de/contact/" />
          <link rel="alternate" hreflang="fr" href="https://iscodingforyou.com/fr/contact/" />
          <link rel="alternate" hreflang="pt-BR" href="https://iscodingforyou.com/pt/contact/" />
          <link rel="alternate" hreflang="sr" href="https://iscodingforyou.com/sr/contact/" />
          <link rel="alternate" hreflang="x-default" href="https://iscodingforyou.com/contact/" />
          
          {/* --- OPEN GRAPH --- */}
          <meta property="og:title" key="og:title" content={t("Contact us")} />
          <meta property="og:site_name" key="og:site_name" content="IsCodingForYou.com" />
          <meta property="og:url" key="og:url" content={lng !== "en" ? `https://iscodingforyou.com/${lng}/contact/` : `https://iscodingforyou.com/contact/`} />
          <meta property="og:type" key="og:type" content="website" />
          <meta property="og:description" key="og:description" content={t("Have questions about our coding potential test? Contact our 24/7 customer support team at support@iscodingforyou.com.")} />
          
          {/* Dinamički locale */}
          <meta property="og:locale" key="og:locale" content={ogLocales[lng] || 'en_US'} />
          <meta property="og:locale:alternate" content="sr_RS" />
          <meta property="og:locale:alternate" content="de_DE" />
          <meta property="og:locale:alternate" content="en_US" />
          <meta property="og:locale:alternate" content="es_ES" />
          <meta property="og:locale:alternate" content="fr_FR" />
          <meta property="og:locale:alternate" content="pt_BR" />

          {/* --- TWITTER CARD --- */}
          <meta name="twitter:card" content="summary" /> 
          <meta name="twitter:site" content="https://iscodingforyou.com/" />
          <meta name="twitter:title" content={t("Contact us")} />
          <meta name="twitter:description" content={t("Have questions about our coding potential test? Contact our customer support team.")} />
        </Helmet>

        <h1 className="home-title-en"> {t("Contact us")} </h1>
        
        {/* Novi, malo profesionalniji uvodni tekst */}
        <p className="contact-subtitle" style={{textAlign: "center", maxWidth: "600px", margin: "0 auto 20px auto", color: "#666"}}>
           {t("Have questions, experiencing payment issues, or need help with your test results? Our support team is here to help.")}
        </p>

        <div className="contact-title" style={{marginTop: "30px"}}>
            <span>{t("Email")} {": "}</span> 
            <a href="mailto:support@iscodingforyou.com" style={{fontWeight: "bold", color: "#030E4F"}}>
              support@iscodingforyou.com
            </a>
        </div>
        
        {/* Ispravljen Link ka Home strani (da gadja korensku rutu a ne /index) */}
        <Link to={lng !== "en" ? `/${lng}/` : `/`} title="Home page" className="home-link">
          <Button
            style={{
              border: "3px solid #030E4F",
              backgroundColor: "#FFD99F",
              color: "#030E4F",
              marginTop: "40px",
              padding: "15px 30px",
              maxWidth: "250px",
              margin: "auto",
              fontWeight: "bold"
            }}
            variant="text"
            size="medium"
            >
            {t("Home page")}
          </Button>
        </Link>
     </div>
  );
};

export default Contact;